<template>
  <v-layout class="password" align-center>
    <v-flex xs12 sm8 md6 lg4 offset-sm2 offset-md3 offset-lg4 v-if="localUser">
      <v-card class="elevation-3" xs12 sm8 md4>
        <v-card-title>
          <v-layout align-center justify-center>
            <v-avatar v-if="userAvatarUrl" size=128>
              <img :src="userAvatarUrl" class="userLogo">
            </v-avatar>
            <v-icon v-else size=128>person_outline</v-icon>
          </v-layout>
        </v-card-title>

        <v-card-text>
          <v-form
            ref="form"
            lazy-validation
            >
            <v-text-field prepend-icon="lock"
              name="password"
              label="Password"
              type="password"
              v-model="localUser.password"
              :rules="[rules.required, rules.min]"
            ></v-text-field>

            <v-text-field prepend-icon="lock"
              name="password_confirmation"
              label="Password confirmation"
              type="password"
              v-model="localUser.password_confirmation"
              :rules="[rules.required, rules.passwordMatch]"
            ></v-text-field>
          </v-form>

          <v-alert :value="updated" color="success" icon="check" outline class="mt-2" > Password updated </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="resetPassword()" :disabled="!(localUser.password && localUser.password_confirmation)">Reset password</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import authentication from '@/utilities/authentication'

  import userService from '@/services/user'
  import authenticationService from '@/services/authentication'

  export default {
    name: 'password-show',

    data () {
      return {
        auth: authentication,
        user: null,
        localUser: null,
        updated: false,
        rules: {
          required: v => !!v || 'Required',
          min: v => (v && (v.length >= 8)) || 'Min 8 characters',
          passwordMatch: (v) => {
            let test = '^' + v
            if (this.password && this.password.match(new RegExp(test))) {
              return true
            } else {
              return 'Passwords don\'t match'
            }
          }
        }
      }
    },

    components: {
    },

    computed: {
      userAvatarUrl () {
        if (this.user && this.user.links && this.user.links.avatar_large_uri) {
          return (process.env.API_URL + this.user.links.avatar_large_uri)
        }
      }
    },

    mounted () {
      this.loadUser()
    },

    methods: {
      loadUser () {
        userService.show(
          (data) => {
            this.user = Object.assign({}, data)
            this.localUser = Object.assign({}, data.attributes)
          },
          (err) => {
            console.log(err)
          },
         this.auth.userId()
        )
      },

      resetPassword () {
        if (this.$refs.form.validate()) {
          authenticationService.resetPassword(
            (data) => {
              this.updated = true
            },
            (err) => {
              console.log(err)
            },
            this.localUser.password,
            this.localUser.password_confirmation,
            this.localUser.perishable_token
          )
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .v-avatar  {
    i {
      border: 2px solid lightgrey !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/password/show.vue